import styled from "styled-components";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { generateDateTime } from "../../services/common-service";
import { useTranslation } from "react-i18next";

const HistoryIcon = styled.div`
  width: 40px;
  height: 40px;
  border: 2px solid var(--color-light-gray);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-light-gray);
  background: #fff;
`;
const ActivityNote = styled.div`
  white-space: pre-line;
`;

const buildOfferActivities = (attempts) =>
  attempts.map((attempt) => ({
    outcome: attempt.outcome?.toLowerCase(),
    note: attempt.notes || "---",
    createdAt: attempt.attemptedAt,
    nextScheduledAt: attempt.nextScheduledAt
  }));

const OfferActivities = ({ attempts }) => {
  const { t } = useTranslation();
  const activities = buildOfferActivities(attempts || []);

  if (!activities.length) {
    return <div className="py-2">{t("offerFollowupAgent.noActivities")}</div>;
  }

  return activities.map((activity, index) => (
    <div key={index} className="mb-2">
      <div className="d-flex align-items-start">
        <HistoryIcon className="position-static flex-shrink-0">
          <FontAwesomeIcon icon={faPhone} />
        </HistoryIcon>
        <div className="flex-fill mx-3">
          <div className="fw-bold">{t("offerFollowupAgent.call")}</div>
          <div>
            {t(`offerFollowupAgent.outcomes.${activity.outcome}`, {
              defaultValue: activity.outcome
            })}
          </div>
          <ActivityNote className="fw-bold">{activity.note}</ActivityNote>
          <div className="text-muted small">
            <div className="fw-bold">
              {t("offerFollowupAgent.activityCreatedAt")}
            </div>
            <div>{generateDateTime(activity.createdAt)}</div>
          </div>
          {activity.nextScheduledAt && (
            <div className="text-secondary small">
              <div className="fw-bold">
                {t("offerFollowupAgent.nextAttempt")}
              </div>
              <div>{generateDateTime(activity.nextScheduledAt)}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  ));
};

export default OfferActivities;
